import React, {useState, useEffect, lazy, Suspense} from "react";
import {openSource} from "../../portfolio";
import Contact from "../contact/Contact";
import Loading from "../loading/Loading";

const renderLoader = () => <Loading />;
const GithubProfileCard = lazy(() =>
  import("../../components/githubProfileCard/GithubProfileCard")
);
export default function Profile() {
  const [prof, setrepo] = useState([]);
  function setProfileFunction(array) {
    setrepo(array);
  }

  useEffect(() => {
    if (openSource.showGithubProfile === "true") {
      const getProfileData = () => {
        // Try multiple paths to ensure it works with different homepage configurations
        const tryFetch = async () => {
          const paths = [
            "/profile.json",
            `${process.env.PUBLIC_URL}/profile.json`,
            "./profile.json"
          ];
          
          for (const path of paths) {
            try {
              const result = await fetch(path);
              if (result.ok) {
                const response = await result.json();
                setProfileFunction(response.data.user);
                return;
              }
            } catch (error) {
              console.warn(`Failed to fetch from ${path}:`, error);
            }
          }
          
          // If all paths fail, throw an error
          throw new Error("Could not fetch profile data from any path");
        };
        
        tryFetch().catch(function (error) {
          console.error(
            `${error} (because of this error GitHub contact section could not be displayed. Contact section has reverted to default)`
          );
          setProfileFunction("Error");
          openSource.showGithubProfile = "false";
        });
      };
      getProfileData();
    }
  }, []);
  if (
    openSource.display &&
    openSource.showGithubProfile === "true" &&
    !(typeof prof === "string" || prof instanceof String)
  ) {
    return (
      <Suspense fallback={renderLoader()}>
        <GithubProfileCard prof={prof} key={prof.id} />
      </Suspense>
    );
  } else {
    return <Contact />;
  }
}
